import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export default function makeDate(data) {
  const sections = {};
  data.forEach((chart) => {
    const monthDate = dayjs(String(chart.연월일시)).format("YYYY-MM-DD");
    if (Array.isArray(sections[monthDate])) {
      sections[monthDate].push(chart);
    } else {
      sections[monthDate] = [chart];
    }
  });
  return sections;
}
